import {createContext} from 'react'

/**
 * Provider and associated hook for accessing the Google Tag Manager Api in React components.
 */
export const GoogleTagManagerContext = createContext()
export const GoogleTagManagerProvider = GoogleTagManagerContext.Provider
